import React from 'react';
import { Menu } from 'semantic-ui-react';
import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import Auth from '../managers/AuthManager';

import '../css/TopNav.less';

const LogoButtons = ({ history, href = undefined, logoImg = undefined, navButton } = {}) => {
  const Logo = SatCoreComponent('Logo');
  const logo = logoImg || Auth.logo;

  return (
    <Menu.Item as='a' header href={href} tabIndex='-1'>
      <Logo history={history} logoImg={logo} navButton={navButton} />
    </Menu.Item>
  );
};

export default LogoButtons;

SatCoreRegister('LogoButtons', LogoButtons);
